import FilterUtils from '@/shared/utils/filters';
import RuleParameters from './rule-parameters.entity';
import RangeParameter from './range-parameter.entity';

export default class Rule {
  id: string;

  name: string;

  parameters: RuleParameters[] = [];

  competence: string;

  faixas: string;

  description: string;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.name = obj.name || '';
    if (obj.parameters) {
      this.parameters = RuleParameters.ofList(obj.parameters)
    }
    this.competence = '';
    this.faixas = obj.faixas || '';
    this.description = obj.description || '';
  }

  public static of(obj: any = {}): Rule {
    return new Rule(obj || {});
  }

  public static ofList(obj: any[]): Rule[] {
    return obj.map(this.of)
  }

  get parametersAsObject(): Object {
    const parametersObject = {};
    this.parameters.forEach((el: RuleParameters) => {
      parametersObject[el.name] = Number(FilterUtils.formatValue(el.value));
    })
    return parametersObject;
  }
}
